import { useQuery } from "@tanstack/react-query";
import { productsServices } from "../services/productsServices.js";
import { useState, useMemo } from "react";
import {
  LoadingSpinner,
  ErrorMessage,
  NotFoundMessage,
  PaginationControls,
} from "../components/auxiliarComponents/auxiliarComponents.jsx";
import CardProduct from "../components/CardProduct/CardProduct.jsx";
import { useSearchParams } from "react-router-dom";

const ITEMS_PER_PAGE = 15;

export default function SearchResults() {
  const [searchParams] = useSearchParams();
  const search = searchParams.get("q") || "";
  const [page, setPage] = useState(1);

  const {
    data: productsResponse,
    isLoading,
    isError,
    isFetching,
    isPreviousData,
  } = useQuery({
    queryKey: ["search-products", search, page],
    queryFn: () =>
      productsServices.getProductsSearch({
        search,
        page,
        limit: ITEMS_PER_PAGE,
      }),
    enabled: !!search,
    keepPreviousData: true,
  });

  const products = useMemo(() => {
    if (!productsResponse) return [];
    if (Array.isArray(productsResponse)) return productsResponse;
    if (productsResponse?.data) return productsResponse.data;
    return [];
  }, [productsResponse]);

  const totalPages = useMemo(() => {
    if (productsResponse?.totalPages) return productsResponse.totalPages;
    if (productsResponse?.total) {
      return Math.ceil(productsResponse.total / ITEMS_PER_PAGE);
    }
    return 0;
  }, [productsResponse]);

  const hasNextPage = page < totalPages;

  if (isLoading && !isPreviousData) {
    return <LoadingSpinner message="Buscando produtos..." />;
  }

  if (isError) {
    return <ErrorMessage message="Erro ao buscar produtos" />;
  }

  return (
    <div className="flex flex-col gap-2 p-2  mmb:mt-48 smb:mt-44 xmb:mt-44 Iphones:mt-44 Iphones2:mt-44 lg:mt-32 xl:mt-32">
      <h2 className="text-2xl md:text-3xl font-bold  uppercase mb-4 m-[1%]">
        Resultados para: <span className="text-green-600">"{search}"</span>
      </h2>

      {products.length === 0 && !isFetching ? (
        <NotFoundMessage message="Nenhum produto encontrado" />
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6 justify-items-center">
            {products.map((product) => (
              <CardProduct key={`${product.id}-${page}`} product={product} />
            ))}
          </div>

          {isFetching && (
            <LoadingSpinner small message="Carregando mais produtos..." />
          )}

          {totalPages > 1 && (
            <PaginationControls
              page={page}
              setPage={setPage}
              hasNextPage={hasNextPage}
              isLoading={isFetching}
              totalPages={totalPages}
            />
          )}
        </>
      )}
    </div>
  );
}
